import { useAuth } from "context/auth/auth";
import { useLayout } from "context/layout/layout";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "services/config";
import logo from "../../assets/white.png";

export default function Login() {
  if (localStorage.getItem("userdata:admin"))
    window.location.replace("/admin/members");
  const auth = useAuth();
  const layout = useLayout();
  const navigate = useNavigate();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = ({ target: { value, name } }) => {
    return setUser({
      ...user,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    if (Object.values(user).some((v) => v === "")) {
      return layout.errorAlert({
        message: "Todos los campos son obligatorios",
      });
    }

    setLoading(true);
    try {
      let isAuthenticated = await auth.requestAuthentication({
        credentials: user,
      });

      if (isAuthenticated) {
        layout.successAlert({
          message: "Authenticacion realizada con exito",
        });

        setTimeout(() => {
          navigate("/admin/members");
        }, 2000);
      }
    } catch (err) {
      return layout.errorAlert({
        message: "Error al iniciar sesion",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div style={{ display: "flex", height: "100vh", width: "100%", overflow: "hidden" }}>
      {/* Left panel - branding */}
      <div
        style={{
          width: "50%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "0 4rem",
          background: "linear-gradient(135deg, #061a40 0%, #0a2a5e 40%, #0353a4 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative circles */}
        <div
          style={{
            position: "absolute",
            top: "-120px",
            right: "-120px",
            width: "400px",
            height: "400px",
            borderRadius: "50%",
            border: "1px solid rgba(255,255,255,0.06)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-200px",
            left: "-100px",
            width: "500px",
            height: "500px",
            borderRadius: "50%",
            border: "1px solid rgba(255,255,255,0.04)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "-50px",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(3,83,164,0.3) 0%, transparent 70%)",
          }}
        />

        <div style={{ position: "relative", zIndex: 1, maxWidth: "480px" }}>
          <img
            src={logo}
            alt="MOCCA"
            style={{ width: "160px", marginBottom: "2.5rem", opacity: 0.95 }}
          />

          <h1
            style={{
              color: "#fff",
              fontSize: "2.25rem",
              fontWeight: 700,
              lineHeight: 1.2,
              marginBottom: "1rem",
              letterSpacing: "-0.02em",
            }}
          >
            Gestiona tu contabilidad
            <br />
            <span style={{ color: "rgba(255,255,255,0.5)", fontWeight: 400 }}>
              desde un solo lugar
            </span>
          </h1>

          <p
            style={{
              color: "rgba(255,255,255,0.55)",
              fontSize: "0.95rem",
              lineHeight: 1.7,
              marginBottom: "2.5rem",
            }}
          >
            Clientes, liquidaciones, reportes y archivos conectados
            con Google Drive. Todo centralizado y automatizado.
          </p>

          {/* Integration badges */}
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
            {[
              { src: `${config.files}/images/drive.png`, name: "Google Drive" },
              { src: `${config.files}/images/icontador.png`, name: "iContador" },
              { src: `${config.files}/images/slack.png`, name: "Slack" },
            ].map((integration) => (
              <div
                key={integration.name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.5rem 0.875rem",
                  borderRadius: "999px",
                  background: "rgba(255,255,255,0.07)",
                  backdropFilter: "blur(8px)",
                  border: "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <img
                  src={integration.src}
                  alt={integration.name}
                  style={{ width: "20px", height: "20px", objectFit: "contain" }}
                />
                <span
                  style={{
                    color: "rgba(255,255,255,0.7)",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  {integration.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right panel - form */}
      <div
        style={{
          width: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f8fafc",
          position: "relative",
        }}
      >
        <div style={{ width: "100%", maxWidth: "400px", padding: "0 2rem" }}>
          {/* Header */}
          <div style={{ marginBottom: "2rem" }}>
            <p
              style={{
                fontSize: "0.75rem",
                color: "#94a3b8",
                fontWeight: 500,
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                marginBottom: "0.5rem",
              }}
            >
              Panel administrativo
            </p>
            <h2
              style={{
                fontSize: "1.5rem",
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: "0.25rem",
              }}
            >
              Iniciar sesion
            </h2>
            <p style={{ fontSize: "0.875rem", color: "#64748b" }}>
              Ingresa tus credenciales para continuar
            </p>
          </div>

          {/* Form */}
          <form autoComplete="on" onSubmit={(e) => e.preventDefault()}>
            <div style={{ marginBottom: "1.25rem" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  color: "#334155",
                  marginBottom: "0.5rem",
                }}
              >
                Correo electronico
              </label>
              <input
                type="email"
                placeholder="nombre@empresa.cl"
                value={user.email}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                autoComplete="email"
                name="email"
                style={{
                  width: "100%",
                  padding: "0.75rem 1rem",
                  fontSize: "0.95rem",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "0.625rem",
                  outline: "none",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                  background: "#fff",
                  color: "#1e293b",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#0353a4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(3,83,164,0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            <div style={{ marginBottom: "1.75rem" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  color: "#334155",
                  marginBottom: "0.5rem",
                }}
              >
                Contrasena
              </label>
              <input
                type="password"
                placeholder="Ingresa tu contrasena"
                value={user.password}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                name="password"
                autoComplete="current-password"
                style={{
                  width: "100%",
                  padding: "0.75rem 1rem",
                  fontSize: "0.95rem",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "0.625rem",
                  outline: "none",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                  background: "#fff",
                  color: "#1e293b",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#0353a4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(3,83,164,0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              type="button"
              style={{
                width: "100%",
                padding: "0.8rem",
                fontSize: "0.95rem",
                fontWeight: 600,
                color: "#fff",
                background: loading
                  ? "#64748b"
                  : "linear-gradient(135deg, #0353a4 0%, #006daa 100%)",
                border: "none",
                borderRadius: "0.625rem",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s",
                boxShadow: "0 2px 8px rgba(3,83,164,0.25)",
                letterSpacing: "0.01em",
              }}
              onMouseEnter={(e) => {
                if (!loading) e.target.style.boxShadow = "0 4px 16px rgba(3,83,164,0.35)";
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = "0 2px 8px rgba(3,83,164,0.25)";
              }}
            >
              {loading ? "Ingresando..." : "Ingresar"}
            </button>
          </form>

          {/* Footer */}
          <p
            style={{
              textAlign: "center",
              fontSize: "0.75rem",
              color: "#94a3b8",
              marginTop: "2rem",
            }}
          >
            Profit Accounting by MOCCA
          </p>
        </div>
      </div>
    </div>
  );
}
